import { c as _c } from "react/compiler-runtime";
import useSWR from 'swr';
import { useEffect } from 'react';
import { logError } from 'commons/logger';
import getEnvValue from 'commons/getEnvValue';
import useIsBrowser from 'hooks/useIsBrowser';
import fetcher from 'commons/fetcher';

// This hook gets the user's location data from the CloudFront API using the
// SWR library to provide caching and prevent excessive API calls.

const apiURL = getEnvValue('NEXT_PUBLIC_USER_LOCATION_CF_API') ?? getEnvValue('REACT_APP_USER_LOCATION_CF_API');
const useCloudfrontLocationAPI = t0 => {
  const $ = _c(9);
  const {
    skip: t1
  } = t0;
  const skip = t1 === undefined ? false : t1;
  const isBrowser = useIsBrowser();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateIfStale: false,
      shouldRetryOnError: false
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    data: location,
    error,
    isLoading
  } = useSWR(isBrowser && !skip ? apiURL : null, fetcher, t2);
  const shouldHaveLoaded = isBrowser && !skip && !isLoading;
  let t3;
  let t4;
  if ($[1] !== error || $[2] !== shouldHaveLoaded) {
    t3 = () => {
      if (shouldHaveLoaded && error) {
        logError(new Error("useCloudfrontLocationAPI", {
          cause: error
        }));
      }
    };
    t4 = [error, shouldHaveLoaded];
    $[1] = error;
    $[2] = shouldHaveLoaded;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] !== error || $[6] !== isLoading || $[7] !== location) {
    t5 = {
      isLoading,
      location,
      error
    };
    $[5] = error;
    $[6] = isLoading;
    $[7] = location;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
export default useCloudfrontLocationAPI;